import React from 'react';

export const Input: React.FC<React.InputHTMLAttributes<HTMLInputElement>> = ({ className, value, ...rest }) => (
  <input
    required
    className={`p-4 border border-solid border-light-silver rounded w-full text-dark-gray text-base font-semibold idz_hide ${className}`}
    value={value}
    {...rest}
  />
);
